import { useParams, Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import PageBanner from "../components/PageBanner";
import { getLegalPage } from "../data/legalContent";

export default function InfoPage() {
  const { slug } = useParams();
  const page = getLegalPage(slug);

  if (!page) {
    return (
      <div className="min-h-screen bg-white text-[#222222]" data-testid="info-page-not-found">
        <Header />
        <div className="frida-container py-32 text-center">
          <h1 className="font-serif text-3xl mb-4">Sayfa bulunamadı</h1>
          <Link to="/" className="text-[#A85C34] font-medium hover:underline">
            Ana sayfaya dön
          </Link>
        </div>
        <Footer />
        <FloatingButtons />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-[#222222]" data-testid="info-page">
      <Header />

      <PageBanner
        eyebrow={page.eyebrow}
        title={page.title}
        subtitle={page.intro}
        breadcrumb={[{ label: page.title }]}
      />

      <section className="py-16 md:py-20 bg-white">
        <div className="frida-container max-w-3xl mx-auto space-y-10">
          {page.sections.map((s) => (
            <div key={s.heading}>
              <h2 className="font-serif text-2xl text-[#222222] mb-4">{s.heading}</h2>
              <div className="space-y-4">
                {s.body.map((p, i) => (
                  <p key={i} className="text-[#555555] leading-relaxed">{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
